import { Link } from 'react-router-dom';

export default function UrbanArtSection() {
  const artworks = [
    {
      id: 1,
      image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/21acdd4a127789415721bd35d26c8e89.jpeg",
      title: "I Love You"
    },
    {
      id: 2,
      image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/ea8aebbf0cd920e837aec61a610e690c.jpeg",
      title: "Escultura Encapuchada"
    },
    {
      id: 3,
      image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/27bfe4bb0588402e544d7175eab08a42.jpeg",
      title: "Hope"
    },
    {
      id: 4,
      image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/e006de72405d03e90d6bc418f9eee144.jpeg",
      title: "Tiburones"
    },
    {
      id: 5,
      image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/1ca496c314dcbde0814615d576a7ebfc.jpeg",
      title: "Street Art"
    },
    {
      id: 6,
      image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/52ffaef7b746ec33c43c1f0fa938c695.jpeg",
      title: "Busto Clásico"
    }
  ];

  return (
    <section className="py-16 md:py-32 bg-neutral-950 relative overflow-hidden">
      <div className="absolute inset-0">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-10"
          style={{
            backgroundImage: 'url("https://public.readdy.ai/ai/img_res/35ebd1d3b68457adc4fc6af753f0f0a8.jpg")'
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-neutral-950 via-transparent to-neutral-950"></div>
      </div>

      <div className="relative max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col items-center text-center mb-10 md:mb-16">
          <div className="inline-block mb-8">
            <span className="text-amber-600 text-sm font-bold uppercase tracking-widest px-4 py-2 border-2 border-amber-600">
              Arte Urbano
            </span>
          </div>

          <blockquote className="max-w-4xl px-2">
            <p 
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6 md:mb-8"
              style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '3px' }}
            >
              "LO QUE NACE EN LA MENTE DEL ARTISTA,<br />
              <span className="text-amber-600">COBRA VIDA EN EL LIENZO DE LA PIEL</span>"
            </p>
          </blockquote>

          <p className="text-neutral-400 text-sm md:text-lg max-w-2xl mt-4 md:mt-6 leading-relaxed px-2">
            El arte urbano es la expresión más pura de nuestra creatividad. Cada trazo, cada sombra, 
            cada detalle nace de una visión que transformamos en realidad.
          </p>
        </div>

        {/* Galería de 6 imágenes centradas */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6 max-w-5xl mx-auto mb-10 md:mb-16">
          {artworks.map((artwork) => (
            <div 
              key={artwork.id}
              className="group relative aspect-square overflow-hidden bg-neutral-900 rounded-lg"
            >
              <img 
                src={artwork.image}
                alt={artwork.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <p className="text-white font-medium text-sm">{artwork.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-4 md:gap-8 flex-wrap">
          <div className="flex flex-col items-center">
            <span className="text-4xl font-bold text-white" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>10+</span>
            <span className="text-neutral-500 text-sm uppercase tracking-wider">Años de Arte</span>
          </div>
          <div className="w-px h-16 bg-neutral-700"></div>
          <div className="flex flex-col items-center">
            <span className="text-4xl font-bold text-white" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>500+</span>
            <span className="text-neutral-500 text-sm uppercase tracking-wider">Obras Creadas</span>
          </div>
          <div className="w-px h-16 bg-neutral-700"></div>
          <div className="flex flex-col items-center">
            <span className="text-4xl font-bold text-white" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>∞</span>
            <span className="text-neutral-500 text-sm uppercase tracking-wider">Pasión Infinita</span>
          </div>
        </div>

        <div className="mt-10 md:mt-16 flex flex-col items-center gap-6 md:gap-8">
          <Link
            to="/galeria-arte-urbano"
            className="px-10 py-4 bg-amber-600 hover:bg-amber-700 text-white text-sm font-bold uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap"
            style={{ clipPath: 'polygon(8px 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%, 0 8px)' }}
          >
            <i className="ri-gallery-line mr-2"></i>
            Ver Galería Completa
          </Link>
          <div className="flex items-center gap-4">
            <div className="w-24 h-0.5 bg-amber-600/50"></div>
            <i className="ri-palette-line text-amber-600 text-2xl"></i>
            <div className="w-24 h-0.5 bg-amber-600/50"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
